<template>
    <div class="content">
        <b-navbar toggleable="lg" type="dark" >
        <b-navbar-brand href="#">
            <img alt="nus logo" src="@/assets/nus-logo.png" height="55" style="margin-right:10px;">
            <img alt="ncript logo" src="@/assets/ncript.svg" height="55">
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
                <b-nav-item href="#"><router-link to="/home">Home</router-link></b-nav-item>
                <b-nav-item href="#"><router-link to="/publication">Publication</router-link></b-nav-item>
                <b-nav-item href="#"><router-link to="/dataset">Dataset</router-link></b-nav-item>
                <b-nav-item href="#"><router-link to="/experiment">Experiment</router-link></b-nav-item>
                <b-nav-item href="#"><router-link to="/code">Code</router-link></b-nav-item>
                
                <b-nav-item-dropdown text="Other Projects" right>
                    <b-dropdown-item href="https://ncript.comp.nus.edu.sg/site/ncript-top/sentiment/">Visual Sentiment</b-dropdown-item>
                    <b-dropdown-item href="https://ncript.comp.nus.edu.sg/site/ncript-top/visualrealism/">Visual Realism</b-dropdown-item>
                    <b-dropdown-item href="https://ncript.comp.nus.edu.sg/site/ncript-top/emotionalattention/">Emotional Attention</b-dropdown-item>
                </b-nav-item-dropdown>

            </b-navbar-nav>
        </b-collapse>
        </b-navbar>
        <hr>
    </div>
</template>

<script>



export default {
  name: 'Menu',
  components:{
  }
}
</script>

<style scoped>
hr{margin-top: 0;}
</style>